export var FeatureSwitch;
(function (FeatureSwitch) {
    FeatureSwitch["SHOW_DEBUG"] = "SHOW_DEBUG";
    FeatureSwitch["SHOW_LOCAL_DEBUG"] = "SHOW_LOCAL_DEBUG";
    FeatureSwitch["SHOW_CREATE_CONVERSATIONS"] = "SHOW_CREATE_CONVERSATIONS";
    FeatureSwitch["SHOW_MANAGE_CONVERSATIONS"] = "SHOW_MANAGE_CONVERSATIONS";
    FeatureSwitch["SHOW_CONVERSATION_ALIAS_BEFORE_PARTIES"] = "SHOW_CONVERSATION_ALIAS_BEFORE_PARTIES";
    FeatureSwitch["SHOW_CONVERSATION_TEAM"] = "SHOW_CONVERSATION_TEAM";
    FeatureSwitch["SHOW_CONV_STAFF_LIST_PARTICIPANTS"] = "SHOW_CONV_STAFF_LIST_PARTICIPANTS";
    FeatureSwitch["SHOW_SMS_MODAL"] = "SHOW_SMS_MODAL";
    FeatureSwitch["SHOW_REMIND_ME"] = "SHOW_REMIND_ME";
    FeatureSwitch["SHOW_CONVERSATION_CONTEXT_BREADCRUMBS"] = "SHOW_CONVERSATION_CONTEXT_BREADCRUMBS";
    FeatureSwitch["SHOW_DOWNLOAD_ALL"] = "SHOW_DOWNLOAD_ALL";
    FeatureSwitch["HIDE_CONV_LIST_PARTICIPANTS"] = "HIDE_CONV_LIST_PARTICIPANTS";
    FeatureSwitch["HIDE_SIDEBAR_USER"] = "HIDE_SIDEBAR_USER";
    FeatureSwitch["HIDE_SIDEBAR_SEARCH"] = "HIDE_SIDEBAR_SEARCH";
    FeatureSwitch["HIDE_SIDEBAR_CONVERSATION_LABEL"] = "HIDE_SIDEBAR_CONVERSATION_LABEL";
    FeatureSwitch["HIDE_CONVERSATION_ALIAS"] = "HIDE_CONVERSATION_ALIAS";
    FeatureSwitch["PERSIST_USER_ACTIONS"] = "PERSIST_USER_ACTIONS";
    FeatureSwitch["LITE_MODE"] = "LITE_MODE";
    FeatureSwitch["IS_TEAM_USER"] = "IS_TEAM_USER";
})(FeatureSwitch || (FeatureSwitch = {}));
//# sourceMappingURL=feature-switches.js.map